import http from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import Raven from 'raven-js';
export const fetchUpgradeConfig = (upgradeKey, retry = true) => {
  return http.get(`${getFullUrl('app-api')}/upgrade-management-service/v1/upgrade-configs/${upgradeKey}`).then(response => response).catch(error => {
    if (retry) {
      return fetchUpgradeConfig(upgradeKey, false);
    }

    if (error && error.status !== 0) {
      Raven.captureException(error);
    }

    throw error;
  });
};